/*
 * @Author: xiaolong.xu
 * @Date: 2023-08-11 15:50:47
 * @LastEditors: 最后编辑
 * @LastEditTime: 2023-08-11 15:52:59
 * @Description: file content
 */
export const EVENT_NEMES = {
  EVENT_PAY: Symbol('EVENT_PAY'),
}
